if ($('body').hasClass('home')) {
    $(window).on('load scroll', (e) => {
        let sliderSection = $('section.slider-section'),
            video = sliderSection.find('video');
        video.bind('contextmenu', function () {
            return false;
        });
        if (sliderSection.isInViewport() === false)
            video[0].pause()
        else
            video[0].play()
    });
}

$(function () {
    // init Swiper
    let testi_slider = new Swiper('.testimonials-slider', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,

        autoplay: {
            delay: 10000
        },

        // If we need pagination
        pagination: {
            el: '.testimonials-pagination .swiper-pagination',
        },

        // Navigation arrows
        navigation: {
            nextEl: '.testimonials-navigation .swiper-button-next',
            prevEl: '.testimonials-navigation .swiper-button-prev',
        }
    })
});
